import View from './ExecuteDeploy';
import enhancer from './ExecuteDeploy.enhancer';

export default enhancer(View);
